/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Settings_TitleInputs */

const en_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Settings`)
};

const fr_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres des sous-titres`)
};

const de_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteleinstellungen`)
};

const it_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni dei sottotitoli`)
};

const ru_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки субтитров`)
};

const es_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de subtítulos`)
};

const zh_cn2_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕设置`)
};

const ja_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕設定`)
};

const hi_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक सेटिंग्स`)
};

const pt_pt2_audio_description_export_subtitle_settings_title = /** @type {(inputs: Audio_Description_Export_Subtitle_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle Settings" |
*
* @param {Audio_Description_Export_Subtitle_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_settings_title = /** @type {((inputs?: Audio_Description_Export_Subtitle_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "de") return de_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "it") return it_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "ru") return ru_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "es") return es_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "ja") return ja_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "hi") return hi_audio_description_export_subtitle_settings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_subtitle_settings_title(inputs)
	return en_audio_description_export_subtitle_settings_title(inputs)
});